/* unplugin-vue-components disabled */import script from "./HomeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeView.vue?vue&type=script&setup=true&lang=ts"

import "./HomeView.vue?vue&type=style&index=0&id=5318825a&scoped=true&lang=css"

import exportComponent from "/Users/shenhao/workDocument/idea/IDEACode/YKWebCode/shaoguanFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5318825a"]])

export default __exports__